import React from "react"
import { Global, css } from "@emotion/core"
import tw from "twin.macro"

import { styles } from "../Styled/Text"
import { styles as ButtonStyles } from "../Styled/Button"
import { useTypography } from "../../hooks/useTypography"
import "swiper/swiper-bundle.min.css"

const Globaltyles = () => {
  const { getTypography } = useTypography()

  return (
    <Global
      styles={css`
        @media screen and (max-height: 880px) {
          .TrustSliderWrapper {
            display: none;
          }
        }
        .inView {
          bottom: 0 !important;
        }
        .ViewPortSection .custom-select__menu {
          top: -70%;
          border-top: 1px solid;
          padding-top: 0;
          margin-top: 0;
          border-radius: 10px;
        }
        .ViewPortSection .custom-select__option {
          font-size: 18px;
          padding: 7px 15px;
        }
        .ViewPortSection .custom-select__menu-list {
          overflow-y: auto;
          max-height: 100px;
        }
        .react-toast-notifications__toast {
          background-color: #000000 !important;
          color: #ffffff !important;
          width: auto !important;
          position: relative;
          border-radius: 10px !important;
        }
        .react-toast-notifications__container.css-16xzlvg-ToastContainer,
        .react-toast-notifications__container.css-wgq3sh {
          bottom: 0 !important;
        }
        .react-toast-notifications__container {
          bottom: -200px !important;
          transition: bottom 0.5s cubic-bezier(0.16, 0.68, 0.43, 0.99);
        }
        .react-toast-notifications__toast__icon-wrapper {
          display: none;
        }
        .react-toast-notifications__toast__dismiss-button {
          position: absolute;
          top: 0;
          right: 0;
        }
        .react-toast-notifications__toast__content {
          font-size: 18px !important;
          padding: 25px 20px !important;
        }
        .react-tel-input.css-1eun7ym-Phone.e1i6pvmg1 {
          padding: 2px 0 0 2px;
        }
        .react-tel-input .form-control {
          width: 100% !important;
          border: 0 !important;
          background: transparent;
          height: 40px;
          font-size: 1.125rem;
        }
        .flag-dropdown {
          border: 0 !important;
          background: transparent !important;
        }
        .TrustSliderWrapper .swiper-pagination.swiper-pagination-bullets {
          bottom: 0 !important;
        }
        @media screen and (max-width: 1000px) and (min-width: 768px) {
          .custom-select__control .custom-select__single-value,
          .hideOption .custom-select__menu {
            font-size: 20px !important;
          }
        }
        .full-100vh {
          height: 100vh;
        }
        .NextButton,
        .PrevButton {
          display: none;
        }
        .featuredCarousal:hover .NextButton,
        .featuredCarousal:hover .PrevButton {
          display: block;
        }
        .featuredCarousal .slick-arrow {
          display: none !important;
        }
        ${getTypography.hero_text && getTypography.hero_text.font_family
          ? `.HeroText{ font-family:  ${getTypography.hero_text.font_family} !important; }`
          : ""}
        ${getTypography.hero_text && getTypography.hero_text.font_size
          ? `.HeroText{ font-size:  ${getTypography.hero_text.font_size} !important; }`
          : ""}
       ${getTypography.hero_text && getTypography.hero_text.line_height
          ? `.HeroText{ line-height:  ${getTypography.hero_text.line_height} !important; }`
          : ""}
       ${getTypography.hero_text && getTypography.hero_text.letter_spacing
          ? `.HeroText{ letter-spacing:  ${getTypography.hero_text.letter_spacing} !important; }`
          : ""}
        
          ${getTypography.hero_sub_text && getTypography.hero_sub_text.font_family
          ? `.HeroSubText{ font-family:  ${getTypography.hero_sub_text.font_family} !important; }`
          : ""}
          ${getTypography.hero_sub_text && getTypography.hero_sub_text.font_size
          ? `.HeroSubText{ font-size:  ${getTypography.hero_sub_text.font_size} !important; }`
          : ""}
         ${getTypography.hero_sub_text && getTypography.hero_sub_text.line_height
          ? `.HeroSubText{ line-height:  ${getTypography.hero_sub_text.line_height} !important; }`
          : ""}
         ${getTypography.hero_sub_text && getTypography.hero_sub_text.letter_spacing
          ? `.HeroSubText{ letter-spacing:  ${getTypography.hero_sub_text.letter_spacing} !important; }`
          : ""}
          
        ${getTypography.heading_1 && getTypography.heading_1.font_family
          ? `h1{ font-family:  ${getTypography.heading_1.font_family} !important; }`
          : ""}
        ${getTypography.heading_1 && getTypography.heading_1.font_size ? `h1{ font-size:  ${getTypography.heading_1.font_size} !important; }` : ""}
      ${getTypography.heading_1 && getTypography.heading_1.line_height
          ? `h1{ line-height:  ${getTypography.heading_1.line_height} !important; }`
          : ""}
          ${getTypography.heading_1 && getTypography.heading_1.letter_spacing
          ? `h1{ letter-spacing:  ${getTypography.heading_1.letter_spacing} !important; }`
          : ""}
      ${getTypography.heading_2 && getTypography.heading_2.font_family
          ? `h2{ font-family:  ${getTypography.heading_2.font_family} !important; }`
          : ""}
      ${getTypography.heading_2 && getTypography.heading_2.font_size ? `h2{ font-size:  ${getTypography.heading_2.font_size} !important; }` : ""}
      ${getTypography.heading_2 && getTypography.heading_2.line_height
          ? `h2{ line-height:  ${getTypography.heading_2.line_height} !important; }`
          : ""}
          ${getTypography.heading_2 && getTypography.heading_2.letter_spacing
          ? `h2{ letter-spacing:  ${getTypography.heading_2.letter_spacing} !important; }`
          : ""}
      ${getTypography.heading_3 && getTypography.heading_3.font_family
          ? `h3{ font-family:  ${getTypography.heading_3.font_family} !important; }`
          : ""}
      ${getTypography.heading_3 && getTypography.heading_3.font_size ? `h3{ font-size:  ${getTypography.heading_3.font_size} !important; }` : ""}
      ${getTypography.heading_3 && getTypography.heading_3.line_height
          ? `h3{ line-height:  ${getTypography.heading_3.line_height} !important; }`
          : ""}
          ${getTypography.heading_3 && getTypography.heading_3.letter_spacing
          ? `h3{ letter-spacing:  ${getTypography.heading_3.letter_spacing} !important; }`
          : ""}
      ${getTypography.heading_4 && getTypography.heading_4.font_family
          ? `h4{ font-family:  ${getTypography.heading_4.font_family} !important; }`
          : ""}
      ${getTypography.heading_4 && getTypography.heading_4.font_size ? `h4{ font-size:  ${getTypography.heading_4.font_size} !important; }` : ""}
      ${getTypography.heading_4 && getTypography.heading_4.line_height
          ? `h4{ line-height:  ${getTypography.heading_4.line_height} !important; }`
          : ""}
          ${getTypography.heading_4 && getTypography.heading_4.letter_spacing
          ? `h4{ letter-spacing:  ${getTypography.heading_4.letter_spacing} !important; }`
          : ""}
     

      ${getTypography.heading_6 && getTypography.heading_6.font_family
          ? `h6{ font-family:  ${getTypography.heading_6.font_family} !important; }`
          : ""}
      ${getTypography.heading_6 && getTypography.heading_6.font_size ? `h6{ font-size:  ${getTypography.heading_6.font_size} !important; }` : ""}
      ${getTypography.heading_6 && getTypography.heading_6.line_height
          ? `h6{ line-height:  ${getTypography.heading_6.line_height} !important; }`
          : ""}
          ${getTypography.heading_6 && getTypography.heading_6.letter_spacing
          ? `h6{ letter-spacing:  ${getTypography.heading_6.letter_spacing} !important; }`
          : ""}
      ${getTypography.paragraph && getTypography.paragraph.font_family ? `p{ font-family:  ${getTypography.paragraph.font_family} !important; }` : ""}
      ${getTypography.paragraph && getTypography.paragraph.font_size ? `p{ font-size:  ${getTypography.paragraph.font_size} !important; }` : ""}
      ${getTypography.paragraph && getTypography.paragraph.line_height ? `p{ line-height:  ${getTypography.paragraph.line_height} !important; }` : ""}
      ${getTypography.paragraph && getTypography.paragraph.letter_spacing
          ? `p{letter-spacing:  ${getTypography.paragraph.letter_spacing} !important; }`
          : ""}
      
      ${getTypography.body && getTypography.body.font_family ? `body, .bodyFont{ font-family:  ${getTypography.body.font_family} !important; }` : ""}
      ${getTypography.body && getTypography.body.font_size ? `body, .bodyFont{ font-size:  ${getTypography.body.font_size} !important; }` : ""}
      ${getTypography.body && getTypography.body.line_height ? `body, .bodyFont{ line-height:  ${getTypography.body.line_height} !important; }` : ""}
      ${getTypography.body && getTypography.body.letter_spacing
          ? `body, .bodyFont{ letter-spacing:  ${getTypography.body.letter_spacing} !important; }`
          : ""}
       
      ${getTypography.smalltext && getTypography.smalltext.font_family
          ? `.StyledSmall{ font-family:  ${getTypography.smalltext.font_family} !important; }`
          : ""}
      ${getTypography.smalltext && getTypography.smalltext.font_size
          ? `.StyledSmall{ font-size:  ${getTypography.smalltext.font_size} !important; }`
          : ""}
      ${getTypography.smalltext && getTypography.smalltext.line_height
          ? `.StyledSmall{ line-height:  ${getTypography.smalltext.line_height} !important; }`
          : ""}
          ${getTypography.smalltext && getTypography.smalltext.letter_spacing
          ? `.StyledSmall{ letter-spacing:  ${getTypography.smalltext.letter_spacing} !important; }`
          : ""}
          ${getTypography.title_reqular && getTypography.title_reqular.font_family
          ? `.title_reqular{ font-family:  ${getTypography.title_reqular.font_family} !important; }`
          : ""}
      ${getTypography.title_reqular && getTypography.title_reqular.font_size
          ? `.title_reqular{ font-size:  ${getTypography.title_reqular.font_size} !important; }`
          : ""}
      ${getTypography.title_reqular && getTypography.title_reqular.line_height
          ? `.title_reqular{ line-height:  ${getTypography.title_reqular.line_height} !important; }`
          : ""}
          ${getTypography.title_reqular && getTypography.title_reqular.letter_spacing
          ? `.title_reqular{ letter-spacing:  ${getTypography.title_reqular.letter_spacing} !important; }`
          : ""}
      ${getTypography.body_regular && getTypography.body_regular.font_family
          ? `.body_regular{ font-family:  ${getTypography.body_regular.font_family} !important; }`
          : ""}
      ${getTypography.body_regular && getTypography.body_regular.font_size
          ? `.body_regular{ font-size:  ${getTypography.body_regular.font_size} !important; }`
          : ""}
      ${getTypography.body_regular && getTypography.body_regular.line_height
          ? `.body_regular{ line-height:  ${getTypography.body_regular.line_height} !important; }`
          : ""}
          ${getTypography.body_regular && getTypography.body_regular.letter_spacing
          ? `.body_regular{letter-spacing:  ${getTypography.body_regular.letter_spacing} !important; }`
          : ""}
      ${getTypography.title_small && getTypography.title_small.font_family
          ? `.title_small, h5{ font-family:  ${getTypography.title_small.font_family} !important; }`
          : ""}
      ${getTypography.title_small && getTypography.title_small.font_size
          ? `.title_small, h5{ font-size:  ${getTypography.title_small.font_size} !important; }`
          : ""}
      ${getTypography.title_small && getTypography.title_small.line_height
          ? `.title_small, h5{ line-height:  ${getTypography.title_small.line_height} !important; }`
          : ""}
          ${getTypography.title_small && getTypography.title_small.letter_spacing
          ? `.title_small, h5{ letter-spacing:  ${getTypography.title_small.letter_spacing} !important; }`
          : ""}
      ${getTypography.body_highlight && getTypography.body_highlight.font_family
          ? `.body_highlight{ font-family:  ${getTypography.body_highlight.font_family} !important; }`
          : ""}
      ${getTypography.body_highlight && getTypography.body_highlight.font_size
          ? `.body_highlight{ font-size:  ${getTypography.body_highlight.font_size} !important; }`
          : ""}
      ${getTypography.body_highlight && getTypography.body_highlight.line_height
          ? `.body_highlight{ line-height:  ${getTypography.body_highlight.line_height} !important; }`
          : ""}
          ${getTypography.body_highlight && getTypography.body_highlight.letter_spacing
          ? `.body_highlight{ letter-spacing:  ${getTypography.body_highlight.letter_spacing} !important; }`
          : ""}  
      ${getTypography.title_extra_small && getTypography.title_extra_small.font_family
          ? `.title_extra_small{ font-family:  ${getTypography.title_extra_small.font_family} !important; }`
          : ""}
      ${getTypography.title_extra_small && getTypography.title_extra_small.font_size
          ? `.title_extra_small{ font-size:  ${getTypography.title_extra_small.font_size} !important; }`
          : ""}
      ${getTypography.title_extra_small && getTypography.title_extra_small.line_height
          ? `.title_extra_small{ line-height:  ${getTypography.title_extra_small.line_height} !important; }`
          : ""}   
          ${getTypography.title_extra_small && getTypography.title_extra_small.letter_spacing
          ? `.title_extra_small{ letter-spacing:  ${getTypography.title_extra_small.letter_spacing} !important; }`
          : ""}         
      ${getTypography.body_small && getTypography.body_small.font_family
          ? `.body_small{ font-family:  ${getTypography.body_small.font_family} !important; }`
          : ""}
      ${getTypography.body_small && getTypography.body_small.font_size
          ? `.body_small{ font-size:  ${getTypography.body_small.font_size} !important; }`
          : ""}
      ${getTypography.body_small && getTypography.body_small.line_height
          ? `.body_small{ line-height:  ${getTypography.body_small.line_height} !important; }`
          : ""}
          ${getTypography.body_small && getTypography.body_small.letter_spacing
          ? `.body_small{ letter-spacing:  ${getTypography.body_small.letter_spacing} !important; }`
          : ""}
      ${getTypography.body_small_highlight && getTypography.body_small_highlight.font_family
          ? `.body_small_highlight{ font-family:  ${getTypography.body_small_highlight.font_family} !important; }`
          : ""}
      ${getTypography.body_small_highlight && getTypography.body_small_highlight.font_size
          ? `.body_small_highlight{ font-size:  ${getTypography.body_small_highlight.font_size} !important; }`
          : ""}
      ${getTypography.body_small_highlight && getTypography.body_small_highlight.line_height
          ? `.body_small_highlight{ line-height:  ${getTypography.body_small_highlight.line_height} !important; }`
          : ""} 
          ${getTypography.body_small_highlight && getTypography.body_small_highlight.letter_spacing
          ? `.body_small_highlight{ letter-spacing:  ${getTypography.body_small_highlight.letter_spacing} !important; }`
          : ""}  
      ${getTypography.body_extra_small && getTypography.body_extra_small.font_family
          ? `.body_extra_small{ font-family:  ${getTypography.body_extra_small.font_family} !important; }`
          : ""}
      ${getTypography.body_extra_small && getTypography.body_extra_small.font_size
          ? `.body_extra_small{ font-size:  ${getTypography.body_extra_small.font_size} !important; }`
          : ""}
      ${getTypography.body_extra_small && getTypography.body_extra_small.line_height
          ? `.body_extra_small{ line-height:  ${getTypography.body_extra_small.line_height} !important; }`
          : ""}  
          ${getTypography.body_extra_small && getTypography.body_extra_small.letter_spacing
          ? `.body_extra_small{ letter-spacing:  ${getTypography.body_extra_small.letter_spacing} !important; }`
          : ""}  
          ${getTypography.menu_level_1 && getTypography.menu_level_1.font_family
          ? `.menu_level_1{ font-family:  ${getTypography.menu_level_1.font_family} !important; }`
          : ""}
        ${getTypography.menu_level_1 && getTypography.menu_level_1.font_size
          ? `.menu_level_1{ font-size:  ${getTypography.menu_level_1.font_size} !important; }`
          : ""}
        ${getTypography.menu_level_1 && getTypography.menu_level_1.line_height
          ? `.menu_level_1{ line-height:  ${getTypography.menu_level_1.line_height} !important; }`
          : ""} 
          ${getTypography.menu_level_1 && getTypography.menu_level_1.letter_spacing
          ? `.menu_level_1{letter-spacing:  ${getTypography.menu_level_1.letter_spacing} !important; }`
          : ""}  
            ${getTypography.menu_level_2 && getTypography.menu_level_2.font_family
          ? `.menu_level_2{ font-family:  ${getTypography.menu_level_2.font_family} !important; }`
          : ""}
          ${getTypography.menu_level_2 && getTypography.menu_level_2.font_size
          ? `.menu_level_2{ font-size:  ${getTypography.menu_level_2.font_size} !important; }`
          : ""}
          ${getTypography.menu_level_2 && getTypography.menu_level_2.line_height
          ? `.menu_level_2{ line-height:  ${getTypography.menu_level_2.line_height} !important; }`
          : ""}
          ${getTypography.menu_level_2 && getTypography.menu_level_2.letter_spacing
          ? `.menu_level_2{letter-spacing:  ${getTypography.menu_level_2.letter_spacing} !important; }`
          : ""}
              ${getTypography.footer_heading && getTypography.footer_heading.font_family
          ? `.footer_heading{ font-family:  ${getTypography.footer_heading.font_family} !important; }`
          : ""}
            ${getTypography.footer_heading && getTypography.footer_heading.font_size
          ? `.footer_heading{ font-size:  ${getTypography.footer_heading.font_size} !important; }`
          : ""}
            ${getTypography.footer_heading && getTypography.footer_heading.line_height
          ? `.footer_heading{ line-height:  ${getTypography.footer_heading.line_height} !important; }`
          : ""}  
          ${getTypography.footer_heading && getTypography.footer_heading.letter_spacing
          ? `.footer_heading{ letter-spacing:  ${getTypography.footer_heading.letter_spacing} !important; }`
          : ""}  
                ${getTypography.footer_menu && getTypography.footer_menu.font_family
          ? `.footer_menu{ font-family:  ${getTypography.footer_menu.font_family} !important; }`
          : ""}
              ${getTypography.footer_menu && getTypography.footer_menu.font_size
          ? `.footer_menu{ font-size:  ${getTypography.footer_menu.font_size} !important; }`
          : ""}
              ${getTypography.footer_menu && getTypography.footer_menu.line_height
          ? `.footer_menu{ line-height:  ${getTypography.footer_menu.line_height} !important; }`
          : ""}
          ${getTypography.footer_menu && getTypography.footer_menu.letter_spacing
          ? `.footer_menu{letter-spacing:  ${getTypography.footer_menu.letter_spacing} !important; }`
          : ""}
          ${getTypography.dprimary_button && getTypography.dprimary_button.font_family
          ? `.primary_button{ font-family:  ${getTypography.dprimary_button.font_family} !important; }`
          : ""}
                ${getTypography.dprimary_button && getTypography.dprimary_button.font_size
          ? `.primary_button{ font-size:  ${getTypography.dprimary_button.font_size} !important; }`
          : ""}
                ${getTypography.dprimary_button && getTypography.dprimary_button.line_height
          ? `.primary_button{ line-height:  ${getTypography.dprimary_button.line_height} !important; }`
          : ""}
          ${getTypography.dprimary_button && getTypography.dprimary_button.letter_spacing
          ? `.primary_button{letter-spacing:  ${getTypography.dprimary_button.letter_spacing} !important; }`
          : ""}
          ${getTypography.dsecondary_button && getTypography.dsecondary_button.font_family
          ? `.secondary_button{ font-family:  ${getTypography.dsecondary_button.font_family} !important; }`
          : ""}
          ${getTypography.dsecondary_button && getTypography.dsecondary_button.font_size
          ? `.secondary_button{ font-size:  ${getTypography.dsecondary_button.font_size} !important; }`
          : ""}
          ${getTypography.dsecondary_button && getTypography.dsecondary_button.line_height
          ? `.secondary_button{ line-height:  ${getTypography.dsecondary_button.line_height} !important; }`
          : ""}  
          ${getTypography.dsecondary_button && getTypography.dsecondary_button.letter_spacing
          ? `.secondary_button{letter-spacing:  ${getTypography.dsecondary_button.letter_spacing} !important; }`
          : ""}  
              
          ${getTypography.body_small_highlight && getTypography.body_small_highlight.font_family
          ? `.body_small_highlight{ font-family:  ${getTypography.body_small_highlight.font_family} !important; }`
          : ""}
          ${getTypography.body_small_highlight && getTypography.body_small_highlight.font_size
          ? `.body_small_highlight{ font-size:  ${getTypography.body_small_highlight.font_size} !important; }`
          : ""}
          ${getTypography.body_small_highlight && getTypography.body_small_highlight.line_height
          ? `.body_small_highlight{ line-height:  ${getTypography.body_small_highlight.line_height} !important; }`
          : ""}     
          ${getTypography.body_small_highlight && getTypography.body_small_highlight.letter_spacing
          ? `.body_small_highlight{ letter-spacing:  ${getTypography.body_small_highlight.letter_spacing} !important; }`
          : ""}  

        .tertiary_button {
          line-height: 22px !important;
        }
        .RegularLink:hover {
          text-decoration: underline;
        }
        .RegularLink {
          font-size: 18px;
          font-family: "Founders Grotesk Regular";
          line-height: 24px;
        }
        /* the slides */
        .blogCarousel .slick-slide {
          padding: 0 10px;
        }
        /* the parent */
        .blogCarousel .slick-list {
          margin: 0px;
        }
        .tagLinksArrow:before {
          content: "";
          width: 0;
          height: 0;
          top: -14px;
          position: absolute;
          border-left: 15px solid transparent;
          border-right: 15px solid transparent;
          border-bottom: 15px solid black;
        }
        .headerwrap {
          transform: translateY(0);
          transition: transform 0.3s ease-in-out;
        }
        .hideheader {
          transform: translateY(-100%);
          transition: transform 0.3s ease-in-out;
        }
        .SingleArticlesWrap h1 strong,
        .SingleArticlesWrap h2 strong,
        .SingleArticlesWrap h3 strong,
        .SingleArticlesWrap h4 strong,
        .SingleArticlesWrap h5 strong,
        .SingleArticlesWrap h6 strong,
        .SingleArticlesWrap .rte strong {
          font-weight: revert;
          font-style: revert;
        }
        html {
          -ms-text-size-adjust: 100%;
          -webkit-text-size-adjust: 100%;
          -ms-overflow-style: none;
          -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
          text-rendering: optimizeLegibility;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          &:focus {
            outline: none !important;
          }
          overflow-y: scroll;
          ${tw`font-body text-16 font-normal leading-1`}
        }
        html,
        body,
        #___gatsby,
        div[role="group"][tabindex] {
          ${tw`h-full`}
        }

        body {
          #___gatsby {
            button,
            input,
            textarea,
            select {
              ${tw`font-body`}
            }
          }
          #___gatsby {
            .navigation-button,
            .circle-button {
              ${tw`font-display`}
            }
          }
          #___gatsby {
            // .secondary-button,
            .icon-button,
            .tight-button {
              ${tw`font-label`}
            }
          }
        }

        input[type="search"]::-webkit-search-decoration,
        input[type="search"]::-webkit-search-cancel-button,
        input[type="search"]::-webkit-search-results-button,
        input[type="search"]::-webkit-search-results-decoration {
          -webkit-appearance: none;
        }

        input[aria-label="MobileSearchForm"],
        input[aria-label="DesktopSearchForm"] {
          padding-left: 0;
        }

        input[aria-label="MobileSearchForm"] + div div {
          padding-top: 5px;
        }
        input[aria-label="DesktopSearchForm"] + div div {
          padding-top: 4px;
        }

        input {
          border-radius: 0;
        }

        input:-webkit-autofill,
        input:-webkit-autofill:hover,
        input:-webkit-autofill:focus,
        input:-webkit-autofill:active {
          -webkit-box-shadow: 0 0 0 30px white inset !important;
        }

        #gorgias-web-messenger-container {
          ${tw`z-20`}
        }
        #gatsby-focus-wrapper {
          ${tw`flex flex-col`}
        }

        .rte {
          ${tw`whitespace-normal break-words`}
          ol,
          ul {
            list-style: none;
            li {
              margin-bottom: 0.5rem;
              display: flex;
              line-height: 1.25rem;
            }
            li:before {
              content: "•";
              font-size: 1rem;
              padding-right: 1rem;
            }
          }
          p {
            strong,
            b {
              ${tw`font-medium font-body`}
            }
            em,
            i {
              ${tw`italic`}
            }
          }
          h1,
          h2,
          h3,
          h4,
          h5,
          h6,
          p {
            ${tw`pb-2-4`}
          }
          img {
            ${tw`mx-auto`}
          }
          h1 {
            ${styles.H1}
          }
          h2 {
            ${styles.H2}
          }
          h3 {
            ${styles.H3}
          }
          h4 {
            ${styles.H4}
          }
          h5 {
            ${styles.H5}
          }
          h6 {
            ${styles.H6}
          }
          p {
            ${styles.P}
          }
          ol {
            ${tw`list-decimal`}
          }
          ul {
            ${tw`list-disc `}
          }
          a {
            ${tw`underline`}
          }
        }
        h1,
        h2,
        h3,
        h4,
        h5,
        h6,
        .rte {
          em {
            ${tw`font-normal`}
          }
          strong {
            ${tw`font-normal not-italic`}
          }
        }
        .underlined-white {
          span {
            position: relative;
            &:after {
              content: "";
              position: absolute;
              background: #fff;
              bottom: -4px;
              left: 0;
              width: 100%;
              height: 1px;
            }
          }
        }
        .underlined-black {
          span {
            position: relative;
            &:after {
              content: "";
              position: absolute;
              background: #000;
              bottom: -4px;
              left: 0;
              width: 100%;
              height: 1px;
            }
          }
          &:hover {
            span:after {
              background: #ba5c27;
            }
          }
        }

        .afterpay-cls-1 {
          fill: #fff;
        }

        .swiper-container {
          width: 100%;
          height: 100%;
        }
        .swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
          // margin: 0 8px;
          margin: 0 !important;
          margin-right: 10px !important;
        }
        .swiper-pagination-bullet {
          // width: 15px;
          // height: 15px;
          // background: #d8d8d8;
          // border-color: #979797;
          // border-width: 1px;
          width: 6.5px;
          height: 8px;
          background: #ffffff;
        }
        .swiper-pagination-bullet-active {
          // background: #525252;
          // border-color: #000000;
          width: 10.5px;
          height: 8px;
          background: #000000;
        }
        .swiper-pagination-bullet {
          border-radius: 50%;
          opacity: 1;
        }

        .swiper-container-horizontal > .swiper-pagination-bullets,
        .swiper-pagination-custom,
        .swiper-pagination-fraction {
          bottom: 35px;
        }
        .okeReviews .okeReviews-reviewsWidget-reviewsAggregate,
        .okeReviews .okeReviews-review-primary,
        .okeReviews-reviewsAggregate-primary,
        .okeReviews-reviewsAggregate-side,
        .okeReviews.okeReviews--theme .okeReviews-reviewsWidget-emptyMessage {
          border: 0 !important;
        }
        #oke-reviews-widget {
          width: 100% !important;
        }
        // .okeReviews .okeReviews-reviewsWidget-header-controls-writeReview {
        //   display: inline-block;
        // }
        .okeReviews .okeReviews-reviewsWidget.is-okeReviews-empty {
          display: block !important;
        }
        .okeReviews .okeReviews-reviewsWidget-reviewsAggregate,
        .okeReviews .okeReviews-review-primary {
          text-align: center;
        }
        .okeReviews .okeReviews-reviewsAggregate-summary-total {
          ${styles.Small}
        }
        .okeReviews .okeReviews-review-reviewer-profile-name {
          ${styles.P}
        }
        .okeReviews .okeReviews-review-main-heading {
          ${styles.H3}
          text-transform: uppercase;
          color: #000;
          font-size: 1.25em !important;
          font-family: Founders Grotesk Bold, sans-serif !important;
        }
        .okeReviews .okeReviews-review-main-content {
          ${styles.P}
          color: #000;
        }
        .okeReviews .okeReviews-review-recommendation {
          ${styles.Small}
        }
        .okeReviews .okeReviews-reviewsAggregate {
          display: flex !important;
          flex-direction: column !important;
          align-items: center !important;
        }
        .okeReviews .okeReviews-reviewsAggregate-summary-rating-value,
        .okeReviews .okeReviews-reviewsAggregate-main {
          display: none !important;
        }
        .okeReviews-reviewsCarousel-review-reviewer {
          display: flex;
          justify-content: center;
        }
        .okeReviews .okeReviews-reviewsWidget--minimal .okeReviews-reviewsAggregate-primary-inner {
          justify-content: flex-end !important;
        }
        .okeReviews .okeReviews-reviewsWidget--minimal.is-okeReviews-reviewsWidget-large .okeReviews-reviewsAggregate-controls {
          flex-flow: row wrap !important;
          width: 100% !important;
        }
        .okeReviews .okeReviews-reviewsWidget-header {
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center !important;
        }
        .okeReviews-reviewsCarousel-review-product-name,
        .okeReviews .okeReviews-reviewsCarousel-header-storeRating,
        .okeReviews-reviewsCarousel-header-reviewsCount,
        .okeReviews .okeReviews-reviewsCarousel-review-reviewer-avatar {
          display: none !important;
        }
        // .okeReviews-reviewsCarousel-review-content-heading {
        // font-weight: 700;
        // font-size: 14px !important;
        // text-transform: uppercase;
        // }
        .okeReviews .okeReviews-reviewsCarousel-review-content-heading {
          ${styles.H3}
          color: #000;
          margin-bottom: 0.625rem !important;
          margin-top: 2.563rem;
          line-height: 22px !important;
          text-transform: uppercase;
          font-size: 1.25em !important;
        }
        .okeReviews-reviewsCarousel-review-reviewer-name {
          color: #000000 !important;
        }
        .okeReviews .okeReviews-reviewsCarousel-review-content-body {
          line-height: 16px !important;
        }
        .okeReviews .okeReviews-reviewsWidget-header-controls-writeReview {
          display: inline-block !important;
          width: auto;
          ${ButtonStyles.layout.primary}
          // border: 1px solid #000000 !important;
          border: none !important;
          color: #000000 !important;
          outline: none !important;
          display: inline-block;
          line-height: 20px !important;
          letter-spacing: 0.8px !important;
        }
        .okeReviews .okeReviews-reviewsWidget-header-controls {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center !important;
        }
        .okeReviews .okeReviews-reviews-main {
          display: flex;
          flex-direction: column;
        }
        .okeReviews .okeReviews-reviews-review {
          width: 100%;
          padding-top: 20px;
          padding-bottom: 20px;
        }
        .okeReviews .okeReviews-review--minimal .okeReviews-review-date {
          float: none !important;
        }
        .okeReviews .okeReviews-review--minimal .okeReviews-review-reviewer {
          float: none !important;
          display: none !important;
        }
        .okeReviews .okeReviews-reviewsWidget--minimal .okeReviews-reviewsAggregate-controls {
          justify-content: center !important;
        }
        .okeReviews .okeReviews-reviewsWidget--minimal .okeReviews-reviewsAggregate-controls-item {
          flex: unset !important;
        }
        .okeReviews .okeReviews-reviewsAggregate-controls-item {
          margin-top: 0 !important;
        }
        .okeReviews .okeReviews-reviews-showMore {
          // border: 1px solid #000 !important;
          ${ButtonStyles.layout.primary}
          font-family: Rodger Black,sans-serif !important;
          font-size: 1.125rem !important;
          letter-spacing: 0.8px !important;
          color: #000 !important;
          border-radius: 8px;
          border: none !important;
          outline: none !important;
          padding-top: 10px !important;
          padding-bottom: 10px !important;
          padding-left: 25px !important;
          padding-right: 25px !important;
          line-height: 20px !important;
          -webkit-transition-property: all;
          transition-property: all;
          -webkit-transition-duration: 500ms;
          transition-duration: 500ms;
        }
        .okeReviews .okeReviews-reviews-showMore:after {
          border: none !important;
          margin-left: 0px !important;
        }
        .okeReviews .okeReviews-reviews-showMore:hover {
          color: #000000 !important;
          background-color: #faf5e0;
        }
        .okeReviews .okeReviews-reviews-showMore:active {
          color: #fbfaf4 !important;
          background-color: #000000 !important;
        }
        .okeReviews .okeReviews-reviewsWidget-header-poweredBy {
          display: none !important;
        }

        .okeReviews .okeReviews-reviewsCarousel-heading {
          font-size: 2.5rem !important;
          letter-spacing: 0.003125rem !important;
          line-height: 1.05 !important;
          padding-bottom: 1.875rem !important;
        }
        .okeReviews .okeReviews-review-recommendation,
        .okeReviews .okeReviews-reviewsCarousel-review-product-image,
        .okeReviews-reviewsCarousel-review-reviewer-date {
          display: none !important;
        }
        .okeReviews .okeReviews-select {
          -webkit-align-items: center;
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          background-color: transparent;
          border-color: #000000 !important;
          border-radius: 0.5rem !important;
          box-shadow: none;
          cursor: default;
          display: -webkit-box;
          display: -webkit-flex;
          display: -ms-flexbox;
          display: flex !important;
          -webkit-box-flex-wrap: wrap;
          -webkit-flex-wrap: wrap;
          -ms-flex-wrap: wrap;
          flex-wrap: wrap;
          -webkit-box-pack: justify;
          -webkit-justify-content: space-between;
          justify-content: space-between;
          outline: 0 !important;
          position: relative;
          -webkit-transition: all 0.2s ease;
          transition: all 0.2s ease;
          box-sizing: border-box;
          width: 100%;
          color: #000000 !important;
          border: 1px solid #000000 !important;
          overflow: hidden;
          z-index: 1;
          font-family: Founders Grotesk Regular, sans-serif;
          letter-spacing: 0.001875rem;
          line-height: 20px;
        }
        .okeReviews .okeReviews-reviews-controls-select {
          background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIj48cGF0aCBkPSJNMTQuNDk2IDUuOTc1bC0uMDAxIDE0LjI4Ny02LjM2Ni02LjM2N0w2IDE2LjAyMWwxMC4wMDMgMTAuMDA0TDI2IDE2LjAyOSAyMy44NzEgMTMuOWwtNi4zNjYgNi4zNjhWNS45Nzd6Ii8+PC9zdmc+")
            no-repeat;
          background-size: 20px;
          background-position: right 10px center, left 10px center;
        }
        .okeReviews .okeReviews-reviewsWidget--minimal.is-okeReviews-reviewsWidget-large .okeReviews-reviewsAggregate-controls-item {
          margin-right: 0.75rem !important;
        }
        .okeReviews .okeReviews-select-input {
          font-size: 24px !important;
          // padding: 0 0.7rem !important;
          padding: 0.5rem 0.7rem !important;
          max-width: calc(100% - 17px) !important;
          overflow: hidden !important;
          text-overflow: ellipsis !important;
          white-space: nowrap !important;
          // line-height: 1.9 !important;
          // align-items: center !important;
        }
        .okeReviews .okeReviews-select-input:focus-visible {
          outline: none !important;
        }
        .okeReviews .okeReviews-select-input option {
          font-size: 24px !important;
        }
        .okeReviews .okeReviews-select:before {
          border-left: none !important;
        }

        .okeReviews .okeReviews-button {
          background: transparent !important;
          padding: 0.5rem 1.25rem !important;
        }
        .okeReviews .okeReviews-button:hover {
          background: #faf5e0 !important;
          color: #000000 !important;
        }
        .okeReviews .okeReviews-button:active {
          background: #000000 !important;
          color: #ffffff !important;
        }
        .okeReviews .okeReviews-select:after,
        .okeReviews .okeReviews-select:before {
          display: none !important;
        }
        .okeReviews-reviewsCarousel-review-reviewer-name,
        .okeReviews-reviewsCarousel-review-content-heading,
        .okeReviews .okeReviews-reviewsCarousel-review-content-body {
          ${styles.P}
          color: #000;
          font-family: Founders Grotesk Regular, sans-serif;
          line-height: 1.8 !important;
        }
        .SingleArticlesWrap a {
          font-size: inherit;
        }
        .SingleArticlesWrap a:hover {
          text-decoration: underline !important;
        }
        .SingleArticlesWrap p {
          font-size: 1rem !important;
          letter-spacing: 0.003125rem !important;
        }
        .SingleArticlesWrap p strong {
          font-size: 1rem !important;
        }
        .ArticlesWrap {
          column-count: 1;
          column-gap: 2em;
        }
        .sizeGIDImage {
          max-height: 100%;
        }
        body.overflow-hidden.sizeGuide {
          height: 100vh;
        }
        .img-wrap {
          max-width: 480px;
          background: #f3f0f6;
          transition: 1s !important;
          right: -2000px !important;
        }
        .img-wrap--scrollable {
          justify-content: start !important;
          overflow-y: scroll;
        }
        .img-wrap.img-unwrap {
          transition: 1s !important;
          right: 0 !important;
        }
        .custom-select__single-value {
          font-size: 18px !important;
        }
        .custom-select__menu {
          font-size: 18px !important;
        }
        #FilterSectionHeight {
          overflow: -moz-scrollbars-none;
          scrollbar-width: none;
          -ms-overflow-style: none;
        }
        #FilterSectionHeight::-webkit-scrollbar {
          width: 0 !important;
          display: none;
        }

        @media screen and (min-width: 48rem) {
          // .okeReviews-reviewsCarousel-review-reviewer-name,
          // .okeReviews-reviewsCarousel-review-content-heading,
          // .okeReviews .okeReviews-reviewsCarousel-review-content-body {
          // font-size: 18px !important;
          // line-height: 20px !important;
          // }
          .ArticlesWrap {
            column-count: 2;
            column-gap: 2em;
          }
          .SingleArticlesWrap p {
            font-size: 2.188rem !important;
            line-height: 41px;
            // font-size: 1.313rem !important;
          }
          .SingleArticlesWrap p strong {
            font-size: 2.188rem !important;
          }
          .okeReviews .okeReviews-reviews-main {
            flex-direction: row;
            flex-wrap: wrap;
          }

          .okeReviews .okeReviews-reviews-review {
            width: 50%;
            padding: 20px;
          }
          .custom-select__single-value {
            font-size: 24px !important;
          }
          .custom-select__menu {
            font-size: 24px !important;
          }
          .okeReviews .okeReviews-select-input {
            font-size: 24px !important;
            // line-height: 1.64 !important;
          }
          .okeReviews .okeReviews-select-input option {
            font-size: 24px !important;
          }
        }
        /* Flickity Previous and Next Buttons */
        .okeReviews.okeReviews--theme .flickity-button-icon {
          display: none;
        }
        .okeReviews .okeReviews-reviewsCarousel-slider .flickity-prev-next-button {
          background-color: transparent !important;
        }
        .okeReviews .okeReviews-reviewsCarousel-slider .flickity-prev-next-button:hover {
          background-color: transparent !important;
        }
        .okeReviews .flickity-prev-next-button {
          top: 13% !important;
          display: none;
        }
        #data-oke-reviews-carousel:hover .okeReviews .flickity-prev-next-button {
          display: block;
        }
        .okeReviews.okeReviews--theme .flickity-prev-next-button.next:after {
          display: block;
          content: " ";
          background-image: url("/icons/new-next-arrow.svg");
          background-repeat: no-repeat;
          height: 56px;
          background-size: cover;
          background-position-x: center;
          /* transform: translateX(-6px) translateY(-1.5px); */
        }
        .okeReviews.okeReviews--theme .flickity-prev-next-button.previous:after {
          display: block;
          content: " ";
          background-position-x: center;
          background-size: cover;
          background-image: url("/icons/new-prev-arrow.svg");
          /*background-image: url("data:image/svg+xml;base64,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"); */
          background-repeat: no-repeat;
          height: 56px;
          /* transform: translateX(-4px) translateY(-2.5px) rotateZ(180deg); */
        }
        @media screen and (max-width: 48rem) {
          .ViewPortSection .custom-select__menu-list {
            max-height: 90px;
          }
          .react-tel-input .form-control {
            height: 32px;
            font-size: 1rem;
          }
          /* the slides */
          .mobOneCol .slick-slide {
            padding: 0px;
          }
          .tertiary_button {
            line-height: 18px !important;
          }
          .NextButton,
          .PrevButton,
          .okeReviews .flickity-prev-next-button,
          #data-oke-reviews-carousel .okeReviews .flickity-prev-next-button {
            display: block;
            height: 35px;
          }
          .okeReviews.okeReviews--theme .flickity-prev-next-button.next:after,
          .okeReviews.okeReviews--theme .flickity-prev-next-button.previous:after {
            height: 35px;
            background-position-x: center;
            background-size: contain;
          }
          ${getTypography.mhero_text && getTypography.mhero_text.font_family
            ? `.HeroText{ font-family:  ${getTypography.mhero_text.font_family} !important; }`
            : ""}
          ${getTypography.mhero_text && getTypography.mhero_text.font_size
            ? `.HeroText{ font-size:  ${getTypography.mhero_text.font_size} !important; }`
            : ""}
        ${getTypography.mhero_text && getTypography.mhero_text.line_height
            ? `.HeroText{ line-height:  ${getTypography.mhero_text.line_height} !important; }`
            : ""}
        ${getTypography.mhero_text && getTypography.mhero_text.letter_spacing
            ? `.HeroText{ letter-spacing:  ${getTypography.mhero_text.letter_spacing} !important; }`
            : ""}
        
          ${getTypography.mhero_sub_text && getTypography.mhero_sub_text.font_family
            ? `.HeroSubText{ font-family:  ${getTypography.mhero_sub_text.font_family} !important; }`
            : ""}
          ${getTypography.mhero_sub_text && getTypography.mhero_sub_text.font_size
            ? `.HeroSubText{ font-size:  ${getTypography.mhero_sub_text.font_size} !important; }`
            : ""}
          ${getTypography.mhero_sub_text && getTypography.mhero_sub_text.line_height
            ? `.HeroSubText{ line-height:  ${getTypography.mhero_sub_text.line_height} !important; }`
            : ""}
          ${getTypography.mhero_sub_text && getTypography.mhero_sub_text.letter_spacing
            ? `.HeroSubText{ letter-spacing:  ${getTypography.mhero_sub_text.letter_spacing} !important; }`
            : ""}    

          .RegularLink {
            font-size: 14px;
            line-height: 16px;
          }
          ${getTypography.mheading_1 && getTypography.mheading_1.font_family
            ? `h1{ font-family:  ${getTypography.mheading_1.font_family} !important; }`
            : ""}
          ${getTypography.mheading_1 && getTypography.mheading_1.font_size
            ? `h1{ font-size:  ${getTypography.mheading_1.font_size} !important; }`
            : ""}
          ${getTypography.mheading_1 && getTypography.mheading_1.line_height
            ? `h1{ line-height:  ${getTypography.mheading_1.line_height} !important; }`
            : ""}
            ${getTypography.mheading_1 && getTypography.mheading_1.letter_spacing
            ? `h1{ letter-spacing:  ${getTypography.mheading_1.letter_spacing} !important; }`
            : ""}
          ${getTypography.mheading_2 && getTypography.mheading_2.font_family
            ? `h2{ font-family:  ${getTypography.mheading_2.font_family} !important; }`
            : ""}
          ${getTypography.mheading_2 && getTypography.mheading_2.font_size
            ? `h2{ font-size:  ${getTypography.mheading_2.font_size} !important; }`
            : ""}
          ${getTypography.mheading_2 && getTypography.mheading_2.line_height
            ? `h2{ line-height:  ${getTypography.mheading_2.line_height} !important; }`
            : ""}
            ${getTypography.mheading_2 && getTypography.mheading_2.letter_spacing
            ? `h2{ letter-spacing:  ${getTypography.mheading_2.letter_spacing} !important; }`
            : ""}
          ${getTypography.mheading_3 && getTypography.mheading_3.font_family
            ? `h3{ font-family:  ${getTypography.mheading_3.font_family} !important; }`
            : ""}
          ${getTypography.mheading_3 && getTypography.mheading_3.font_size
            ? `h3{ font-size:  ${getTypography.mheading_3.font_size} !important; }`
            : ""}
          ${getTypography.mheading_3 && getTypography.mheading_3.line_height
            ? `h3{ line-height:  ${getTypography.mheading_3.line_height} !important; }`
            : ""}
            ${getTypography.mheading_3 && getTypography.mheading_3.letter_spacing
            ? `h3{ letter-spacing:  ${getTypography.mheading_3.letter_spacing} !important; }`
            : ""}
          ${getTypography.mheading_4 && getTypography.mheading_4.font_family
            ? `h4{ font-family:  ${getTypography.mheading_4.font_family} !important; }`
            : ""}
          ${getTypography.mheading_4 && getTypography.mheading_4.font_size
            ? `h4{ font-size:  ${getTypography.mheading_4.font_size} !important; }`
            : ""}
          ${getTypography.mheading_4 && getTypography.mheading_4.line_height
            ? `h4{ line-height:  ${getTypography.mheading_4.line_height} !important; }`
            : ""}
    
    
          ${getTypography.mheading_6 && getTypography.mheading_6.font_family
            ? `h6{ font-family:  ${getTypography.mheading_6.font_family} !important; }`
            : ""}
          ${getTypography.mheading_6 && getTypography.mheading_6.font_size
            ? `h6{ font-size:  ${getTypography.mheading_6.font_size} !important; }`
            : ""}
          ${getTypography.mheading_6 && getTypography.mheading_6.line_height
            ? `h6{ line-height:  ${getTypography.mheading_6.line_height} !important; }`
            : ""}
    
          ${getTypography.mbody && getTypography.mbody.font_family
            ? `body, .bodyFont{ font-family:  ${getTypography.mbody.font_family} !important; }`
            : ""}
          ${getTypography.mbody && getTypography.mbody.font_size ? `body, .bodyFont{ font-size:  ${getTypography.mbody.font_size} !important; }` : ""}
          ${getTypography.mbody && getTypography.mbody.line_height
            ? `body, .bodyFont{ line-height:  ${getTypography.mbody.line_height} !important; }`
            : ""}
            ${getTypography.mbody && getTypography.mbody.letter_spacing
            ? `body, .bodyFont{ letter-spacing:  ${getTypography.mbody.letter_spacing} !important; }`
            : ""}
            ${getTypography.msmalltext && getTypography.msmalltext.font_family
            ? `.StyledSmall{ font-family:  ${getTypography.msmalltext.font_family} !important; }`
            : ""}
            ${getTypography.msmalltext && getTypography.msmalltext.font_size
            ? `.StyledSmall{ font-size:  ${getTypography.msmalltext.font_size} !important; }`
            : ""}
            ${getTypography.msmalltext && getTypography.msmalltext.line_height
            ? `.StyledSmall{ line-height:  ${getTypography.msmalltext.line_height} !important; }`
            : ""}  
            ${getTypography.msmalltext && getTypography.msmalltext.letter_spacing
            ? `.StyledSmall{ letter-spacing:  ${getTypography.msmalltext.letter_spacing} !important; }`
            : ""} 
          ${getTypography.mparagraph && getTypography.mparagraph.font_family
            ? `p{ font-family:  ${getTypography.mparagraph.font_family} !important; }`
            : ""}
          ${getTypography.mparagraph && getTypography.mparagraph.font_size
            ? `p{ font-size:  ${getTypography.mparagraph.font_size} !important; }`
            : ""}
          ${getTypography.mparagraph && getTypography.mparagraph.line_height
            ? `p{ line-height:  ${getTypography.mparagraph.line_height} !important; }`
            : ""}
            ${getTypography.mparagraph && getTypography.mparagraph.letter_spacing
            ? `p{ letter-spacing:  ${getTypography.mparagraph.letter_spacing} !important; }`
            : ""}
          ${getTypography.mbody_regular && getTypography.mbody_regular.font_family
            ? `.body_regular{ font-family:  ${getTypography.mbody_regular.font_family} !important; }`
            : ""}
          ${getTypography.mbody_regular && getTypography.mbody_regular.font_size
            ? `.body_regular{ font-size:  ${getTypography.mbody_regular.font_size} !important; }`
            : ""}
          ${getTypography.mbody_regular && getTypography.mbody_regular.line_height
            ? `.body_regular{ line-height:  ${getTypography.mbody_regular.line_height} !important; }`
            : ""}
            ${getTypography.mbody_regular && getTypography.mbody_regular.letter_spacing
            ? `.body_regular{ letter-spacing:  ${getTypography.mbody_regular.letter_spacing} !important; }`
            : ""}
            ${getTypography.mfooter_heading && getTypography.mfooter_heading.font_family
            ? `.footer_heading{ font-family:  ${getTypography.mfooter_heading.font_family} !important; }`
            : ""}
            ${getTypography.mfooter_heading && getTypography.mfooter_heading.font_size
            ? `.footer_heading{ font-size:  ${getTypography.mfooter_heading.font_size} !important; }`
            : ""}
            ${getTypography.mfooter_heading && getTypography.mfooter_heading.line_height
            ? `.footer_heading{ line-height:  ${getTypography.mfooter_heading.line_height} !important; }`
            : ""}
            ${getTypography.mfooter_heading && getTypography.mfooter_heading.letter_spacing
            ? `.footer_heading{ letter-spacing:  ${getTypography.mfooter_heading.letter_spacing} !important; }`
            : ""}
              ${getTypography.mfooter_menu && getTypography.mfooter_menu.font_family
            ? `.footer_menu{ font-family:  ${getTypography.mfooter_menu.font_family} !important; }`
            : ""}
              ${getTypography.mfooter_menu && getTypography.mfooter_menu.font_size
            ? `.footer_menu{ font-size:  ${getTypography.mfooter_menu.font_size} !important; }`
            : ""}
              ${getTypography.mfooter_menu && getTypography.mfooter_menu.line_height
            ? `.footer_menu{ line-height:  ${getTypography.mfooter_menu.line_height} !important; }`
            : ""}
            ${getTypography.mfooter_menu && getTypography.mfooter_menu.letter_spacing
            ? `.footer_menu{ letter-spacing:  ${getTypography.mfooter_menu.letter_spacing} !important; }`
            : ""}
            ${getTypography.secondary_button_small && getTypography.secondary_button_small.font_family
            ? `.secondary_button{ font-family:  ${getTypography.secondary_button_small.font_family} !important; }`
            : ""}
                      ${getTypography.secondary_button_small && getTypography.secondary_button_small.font_size
            ? `.secondary_button{ font-size:  ${getTypography.secondary_button_small.font_size} !important; }`
            : ""}
                      ${getTypography.secondary_button_small && getTypography.secondary_button_small.line_height
            ? `.secondary_button{ line-height:  ${getTypography.secondary_button_small.line_height} !important; }`
            : ""}  
              ${getTypography.secondary_button_small && getTypography.secondary_button_small.letter_spacing
            ? `.secondary_button{letter-spacing:  ${getTypography.secondary_button_small.letter_spacing} !important; }`
            : ""}  
               
                  
          .okeReviews .okeReviews-reviewsCarousel-heading {
            font-family: "Founders Grotesk Regular", sans-serif !important;
            font-size: 1.625rem !important;
            letter-spacing: 0.001875rem !important;
            line-height: 1.08 !important;
            width: 66.6667% !important;
            margin: auto !important;
            padding-top: 1rem !important;
            padding-bottom: 1rem !important;
            text-align: center !important;
          }
          // .okeReviews .okeReviews-reviewsCarousel-review-content-heading {
          //   margin-bottom: 0.75rem !important;
          //   margin-top: 0.813rem !important;
          //   font-size: 14px !important;
          // }

          .okeReviews .okeReviews-review-main-heading {
            font-size: 14px !important;
          }

          .okeReviews .okeReviews-reviewsWidget--minimal .okeReviews-reviewsAggregate-controls-item {
            margin-bottom: 0.625rem !important;
          }
          .okeReviews .okeReviews-reviews-showMore {
            font-size: 1.125rem !important;
          }
        }
      `}
    />
  )
}

export default Globaltyles
